import React from "react"
import{Link} from 'react-router-dom'
import liftmain from "../imgs/liftmain.png"
import "./allinfo.css"

const Liftinfo=()=>{
	return(
			<div>
			<img src={liftmain} className="liftmain" alt="liftinfo"/>
			<Link to="/animation"><button className="button">Animation</button></Link>
			<div className="liftdiv"><p>
<strong>Lift</strong> is the force that holds an aircraft in the air. Lift is an aerodynamic force produced by the motion of a fluid past an object. Lift acts through the center of pressure of the object and is defined to be perpendicular to the flow direction.

Lift occurs when a flow of gas is turned by a solid object. The flow is turned in one direction, and the lift is generated in the opposite direction, according to Newton's Third Law of action and reaction. Because air is a gas and the molecules are free to move about, any solid surface can deflect a flow. For an airfoil, both the upper and lower surfaces contribute to the flow turning. 

Lift is a mechanical force. It is generated by the interaction and contact of a solid body with a fluid (liquid or gas).  For lift to be generated, the solid body must be in contact with the fluid. Lift is generated by the difference in velocity between the solid object and the fluid. There must be motion between the object and the fluid: no motion, no lift. It makes no difference whether the object moves through a static fluid, or the fluid moves past a static solid object. Lift acts perpendicular to the motion.

All that is necessary to create lift is to turn a flow of air. An aerodynamic, curved airfoil will turn a flow. But so will a simple flat plate, if it is inclined to the flow. 

Factors that affect lift</p>
<p>

There are many factors that affect the turning of the flow, which creates lift. We can group these factors into:-</p>

(a)  Those associated with the object, (b) Those associated with the motion of the object through the air, and (c) Those associated with the air itself:<br/><br/>


a.                  Object: At the top of the figure, aircraft wing geometry has a large effect on the amount of lift generated. The airfoil shape and wing size will both affect the amount of lift. The ratio of the wing span to the wing area also affects the amount of lift generated by a wing.<br/>


b.     Motion: To generate lift, we have to move the object through the air. The lift then depends on velocity of the air and how the object is inclined to the flow.<br/>


c.      Air: Lift depends on the mass of the flow. The lift also depends in a complex way on two other properties of the air: its viscosity and its compressibility.<br/>

<br/>
<br/>

<strong>Equation for Lift</strong><br/>
<br/>


Lift depends on the density of the air, the square of the velocity, the air's viscosity and compressibility, the surface area over which the air flows, the shape of the body, and the body's inclination to the flow. One way to deal with complex dependencies is to characterize the dependence by a single variable. For lift, this variable is called the lift coefficient, designated "Cl." The lift equation states that lift L is equal to the lift coefficient Cl times the density r times half of the velocity V squared times the wing area A.<br/>
<br/>


Lift = Cl * A *0.5 * r * V^2<br/>
<br/>
<br/>
<br/>


<strong>Coefficient of Lift</strong><br/>
<br/>


For given air conditions, shape, and inclination of the object, we have to determine a value for Cl to determine the lift. For some simple flow conditions and geometries and low inclinations, aerodynamicists can determine the value of Cl mathematically. But, in general, this parameter is determined experimentally.

Here is a way to determine a value for the lift coefficient. In a controlled environment we can set the velocity, density, and area and measure the lift produced. Through division, we arrive at a value for the lift coefficient. We can then predict the lift that will be produced under a different set of velocity, density (altitude), and area conditions using the lift equation

			</div>
			</div>
		);
}

export default Liftinfo;